<template>
  <div>
  <TosListVuetify serviceName="yard" entityName="visits" :excludeButtons="{'add':true}"  >
    <template #customFilters="slotProps">
      <v-container fluid>
       <v-row>
         <v-col>
            <v-select :label="tLabel('System Type')"  v-model="slotProps.data.sysType" :items="sysTypes" />
          </v-col>
          <v-col cols="4">
            <v-text-field  :label="tLabel('Unit number')" v-model="slotProps.data.objectCode" />
          </v-col>
          <v-col cols="4">
            <v-text-field  :label="tLabel('Alternative Code')" v-model="slotProps.data.altCode" />
          </v-col>
       </v-row>
      </v-container>
    </template>

  </TosListVuetify>

</div>

</template>


<script>
import TosListVuetify from '../../../components/anagrafiche/TosListVuetify';
import FormatsMixins from "../../../mixins/FormatsMixins";
import YardEnumMixin from "../../../mixins/yard/EnumMixin";

export default {
  name: "Visits",
  data() {
    return {
      item: null,
      headers: [
        { text: "", value: "action" },
        { text: "ID", value: "id" },
        { text: "Codice", value: "objectCode" },
        { text: "Systype", value: "sysType" },
        { text: "qty", value: "qty" },
        { text: "grossweight", value: "grossweight" },
        { text: "goods", value: "goods" },
      ],
    };
  },
  service: null,
  mounted(){
  },
  
  methods: {
    async prepareItem(data) {
      if(data.id==null){
        data.customsStatus='D';
        data.role="UNT";
        data.sysType="UNT";

      }
    },
  },
  components: {TosListVuetify},
  mixins: [FormatsMixins, YardEnumMixin],
};
</script>
